<template>
    <div class="step-indicator">
        {{ wizard.currentStepNumber }}/{{ wizard.steps.length }}
    </div>
</template>

<script>
export default {
  props: {
    wizard: {
      required: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/login/modal/step-indicator.vue